import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100/80 text-accent-700 text-xs font-semibold rounded-full mb-3">
            焦点专题
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            特别策划
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            深度聚焦影视行业热点，发现好内容背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {carouselData.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden hover:border-accent-200 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <h3 className="text-lg md:text-xl font-black text-foreground-950 group-hover:text-accent-600 transition-colors duration-200 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-accent-600 group-hover:gap-2 transition-all duration-200">
                  阅读全文
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}